export const GET_LIST_OF_STUDENTS_REQUEST = 'GET_LIST_OF_STUDENTS_REQUEST';
export const GET_LIST_OF_STUDENTS_SUCCESS = 'GET_LIST_OF_STUDENTS_SUCCESS';
export const GET_LIST_OF_STUDENTS_FAILURE = 'GET_LIST_OF_STUDENTS_FAILURE';
export const CLEAR_LIST_OF_STUDENTS = 'CLEAR_LIST_OF_STUDENTS';

export const DELETE_STUDENT_REQUEST = 'DELETE_STUDENT_REQUEST';
export const DELETE_STUDENT_SUCCESS = 'DELETE_STUDENT_SUCCESS';
export const DELETE_STUDENT_FAILURE = 'DELETE_STUDENT_FAILURE';
